import {h, Fragment} from "preact"
export default function LoadButton (){
    return(
        <div class="btn load-more-button">Last inn flere produkter</div>
    )
}